<!-- Global loading skeleton -->
@if (loading) {
  @for (i of [1,2,3,4]; track i) {
    <div class="loading-skeleton mt-20">
      <div class="loading-skeleton__inner">
        <div class="loading-skeleton__content">
          <div class="loading-skeleton__title"></div>
          <div class="loading-skeleton__text"></div>
          <div class="loading-skeleton__text"></div>
        </div>
      </div>
    </div>
  }
}

<!-- Start event details -->
@if (display_type === 1 && !loading) {
  <div class="central-header central-header--claims d-none d-md-flex">
    <h3 class="font-normal">{{claim_details?.claim_name}}</h3>
    <div class="dropdown d-none d-md-inline-block">
    </div>
  </div>
  <div class="policy-card__summary mb-15 d-none d-md-block">
    <div class="policy-card__summary-inner seemore__expander" id="personal-item-5-more">
      <div class="policy-card__summary-items">
        <ul class="summary-list list-unstyled summary-list--tracker">
          <li>
            <small>Claim Ref No.</small>
            <span class="font-bold">{{claim_details?.claim_id}}/{{claim_details?.claim_version_id}}</span>
          </li>
          <li>
            <small>Policy No.</small>
            <span class="font-semibold">{{claim_details?.policy_id}}/{{claim_details?.version_id}}</span>
          </li>
          <li>
            <small>Estimated Value</small>
            <span class="font-semibold">-</span>
          </li>
          <li>
            <small>Amount Paid</small>
            <span class="font-semibold">-</span>
          </li>
          <li>
            <small>Status</small>
            <span class="tag-pill tag-pill--active"> <svg class="icon"><use xlink:href="#complete"></use></svg>
          {{claim_details?.claim_status}} </span>
        </li>
      </ul>
    </div>
  </div>
</div>
@if (isSkipped) {
  <div class="card card--post-header card--notification mt-30">
    <div class="card-body">
      <div class="card__avatar">
        <picture>
          <source media="(min-width: 768px)" srcset="/assets/0/avatar/face-thinking.png">
          <img src="/assets/0/avatar/thinking.png" alt="" class="img-fluid">
        </picture>
      </div>
      <div class="card__content">
        <div class="card__copy">
          <!-- <p class="text-center text-md-left">Your claim has been registered. We will get back to you with next the steps
        - expect to hear from us within one to two business days. </p> -->
      </div>
      <div class="note mt-15">
        <div class="note__icon">
          <svg class="icon">
            <use xlink:href="#info"></use>
          </svg>
        </div>
        <div class="note__content">
          <h6>Some details were skipped</h6>
          <p>Skipped details prevent progress of your claim. You will be reminded to complete these.</p>
        </div>
      </div>
    </div>
  </div>
</div>
}
@if (claim_details?.claim_status == 'Registered') {
  <div class="card card--post-header card--notification mt-30">
    <div class="card-body">
      <div class="card__avatar">
        <picture>
          <source media="(min-width: 768px)" srcset="assets/0/avatar/face-happy.png">
          <img src="assets/0/avatar/happy.png" alt="" class="img-fluid">
        </picture>
      </div>
      <div class="card__content">
        <div class="card__copy">
          <p class="text-center text-md-left">Your claim has been registered. We will get back to you with next the steps
          - expect to hear from us within one to two business days. </p>
        </div>
      </div>
    </div>
  </div>
}
<div class="central-header central-header--claims central-header--claims-sm d-md-none">
  <h3 class="font-normal">{{claim_details?.claim_name}}</h3>
  <!-- <div class="dropdown d-md-none">
  <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
    data-toggle="dropdown" aria-expanded="false">
    <svg class="icon">
      <use xlink:href="#more"></use>
    </svg>
  </a>
  <a href="#modal-traymenu-actions"
    class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
    <svg class="icon">
      <use xlink:href="#more"></use>
    </svg>
  </a>
  <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
    <a class="dropdown-item" data-sortby="best_value">
      <svg class="icon">
        <use xlink:href="#add-items"></use>
      </svg>
      <span>Add Item or Benefit</span>
    </a>
    <a class="dropdown-item" data-sortby="best_value">
      <svg class="icon text-color-error">
        <use xlink:href="#trash-bin"></use>
      </svg>
      <span>Cancel Claim</span>
    </a>
  </div>
</div> -->
</div>
<div class="card card--edit card--edit-summary">
  <div class="card-body">
    <div class="card__content">
      <h4 class="pb-30">Event Details</h4>
      @for (question of eventDetailQuestions; track question; let last = $last) {
        <app-question-controller
          [question]="question"
          [isEditModal]="true"
          [showLabel]="true"
          [controlCssClass]="(question?.highlight || '') + ' form-group ' + (!last ? 'mb-40' : '')"
          (questionAnswer)="questionResponse($event)">
        </app-question-controller>
      }
    </div>
  </div>
</div>
}
<!--End Event Details-->


<!-- Item Details -->
@if (display_type === 2 && !loading) {
  <div class="central-header central-header--claims">
    <h3 class="font-normal">{{cart_item?.description ? cart_item?.description?.split('|')[0] : ''}}</h3>
    <div class="dropdown d-none d-md-inline-block">
      <a href="#" class="dropdown-toggle dropdown-toggle--central dropdown-toggle--more d-none d-md-block"
        data-toggle="dropdown" aria-expanded="false">
        <svg class="icon">
          <use xlink:href="#more"></use>
        </svg>
      </a>
      <a href="#modal-traymenu-actions"
        class="dropdown-toggle dropdown-toggle--central dropdown-toggle--nocaret d-md-none" data-toggle="modal">
        <svg class="icon">
          <use xlink:href="#more"></use>
        </svg>
      </a>
      <div class="dropdown-menu dropdown-menu-right dropdown-menu--central">
        <!--<a class="dropdown-item" data-sortby="best_value">
        <svg class="icon">
          <use xlink:href="#pause"></use>
        </svg>
        <span>Pause Claim</span>
      </a>-->
      <a class="dropdown-item" data-sortby="best_value" (click)="removeItem.emit({item: cart_item})">
        <svg class="icon">
          <use xlink:href="#trash-bin"></use>
        </svg>
        <span>Remove</span>
      </a>
    </div>
  </div>
</div>
@if (isGroupsLoading) {
  @for (i of [1,2,3]; track i) {
    <div class="loading-skeleton mt-20">
      <div class="loading-skeleton__inner">
        <div class="loading-skeleton__content">
          <div class="loading-skeleton__title"></div>
          <div class="loading-skeleton__text"></div>
          <div class="loading-skeleton__text"></div>
        </div>
      </div>
    </div>
  }
}
<div class="mt-20" id="group-items-accordion" [class.d-none]="isGroupsLoading">
  @for (group of detailGroups; track trackByGroup($index, group); let first = $first) {
    @if (group?.class_id === cart_item?.class_id) {
      <div class="card card--freeform">
        <a [href]="'#' + group?.group_type + '-' + group?.class_id" class="card-title" [class.highlight-red]="groupHasHighlight(group)" data-toggle="collapse" aria-expanded="true">
          <div class="card-title__text">
            <div class="card-title__text-wrap">
              <h5 class="font-16 font-semibold">{{group?.group_name}}</h5>
            </div>
          </div>
          <div class="card-title__caret">
            <svg class="icon">
              <use xlink:href="#dropdown"></use>
            </svg>
          </div>
        </a>
        <div class="card-body collapse show" [id]="group?.group_type + '-' + group?.class_id">
          <div class="card__content">
            @for (question of group?.questions; track question) {
              <app-question-controller
                [showLabel]="true"
                [isEditModal]="true"
                [editModal]="true"
                [damageModalNarrow]="true"
                [showSkip]="false"
                [showParent]="false"
                [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
                [question]="question"
                [controlCssClass]="question?.highlight+' form-group'" (questionAnswer)="questionResponse($event)">
              </app-question-controller>
              @if (question?.skipped_details?.length) {
                @for (detail of question.skipped_details; track detail) {
                  <div class="position-relative">
                    <div class="note mt-15 mb-30">
                      <div class="note__icon">
                        <svg class="icon">
                          <use xlink:href="#warning"></use>
                        </svg>
                      </div>
                      <div class="note__content">
                        <h6>{{detail.header}}</h6>
                        <p>{{detail.body}}</p>
                      </div>
                    </div>
                  </div>
                }
              }
            }
          </div>
        </div>
      </div>
    }
  }
</div>
}

@if (display_type === 3) {
  <div class="central-header central-header--claims">
    <h3 class="font-normal">{{cart_item?.description ? cart_item?.description?.split('|')[0] : ''}}</h3>
  </div>
  <div class="card card--edit">
    <!-- <div class="card-title">
    <h4>Police Report Details</h4>
  </div> -->
  <div class="card-body">
    <div class="card__content">
      <!-- <h4 class="pb-30">Police Report Details</h4> -->
      @for (question of policeReportQuestions; track question) {
        <app-question-controller
          [showLabel]="true"
          [damageModalNarrow]="true"
          [showSkip]="false"
          [showParent]="false"
          [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
          [question]="question"
          [controlCssClass]="question?.highlight+' form-group'"
          (questionAnswer)="questionResponse($event)">
        </app-question-controller>
        @if (question?.skipped_details?.length) {
          @for (detail of question.skipped_details; track detail) {
            <div class="position-relative">
              <div class="note mt-15 mb-30">
                <div class="note__icon">
                  <svg class="icon">
                    <use xlink:href="#warning"></use>
                  </svg>
                </div>
                <div class="note__content">
                  <h6>{{detail.header}}</h6>
                  <p>{{detail.body}}</p>
                </div>
              </div>
            </div>
          }
        }
      }
    </div>
  </div>
</div>
<!-- <div class="mt-20" id="group-items-accordion">
<ng-container *ngFor="let group of questionGroups; trackBy: trackByGroup">
  <div class="card card--freeform" *ngIf="group?.class_id === cart_item?.class_id">
    <a [href]="'#' + group?.group_type + '-' + group?.class_id" class="card-title collapsed" data-toggle="collapse" aria-expanded="false">
      <div class="card-title__text">
        <div class="card-title__text-wrap">
          <h5 class="font-16 font-semibold">{{group?.group_name}}</h5>
        </div>
      </div>
      <div class="card-title__caret">
        <svg class="icon">
          <use xlink:href="#dropdown"></use>
        </svg>
      </div>
    </a>
    <div class="card-body collapse" [id]="group?.group_type + '-' + group?.class_id" [attr.data-parent]="'#group-items-accordion'">
      <div class="card__content">
        <app-question-controller
          *ngFor="let question of group?.questions"
          [showLabel]="true"
          [damageModalNarrow]="true"
          [showSkip]="false"
          [showParent]="false"
          [childItemQuestions]="getChildQuestions(question?.cent_aq_question_id, question?.item_id)"
          [question]="question"
          (questionAnswer)="questionResponse($event)">
        </app-question-controller>
      </div>
    </div>
  </div>
</ng-container>
</div> -->
}

<div class="modal fade modal--alert" id="modal-additional" tabindex="-1" role="dialog"
  aria-labelledby="modal-additional-qs-1" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session_details?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <div class="rte">
            <h3>Changing this answer may require additional questions.</h3>
            <p>Note that changes may affect your premium. All previously answered questions that don’t require changes
            will still be saved.</p>
          </div>

        </div>
      </div>

      <div class="modal-alert__button">
        <div class="container">
          <a href="#" class="button button--lg button--secondary" data-dismiss="modal">Cancel</a>
          <a href="#" class="button button--lg button--primary" (click)="startFlow()" data-toggle="modal"
          data-dismiss="modal">Got it</a>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade modal--alert" id="modal-miniflow" tabindex="-1" role="dialog"
  aria-labelledby="modal-additional-qs-1" aria-modal="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content modal-alert modal-alert--alt">

      <div class="modal-alert__heading">
        <div class="container">
          <div class="modal-alert__avatar">
            <img src="assets/{{session_details?.category_id}}/avatar/happy.png" class="img-fluid" alt="">
          </div>
          <button class="modal-alert__close" data-dismiss="modal">
            <svg class="icon">
              <use xlink:href="#close-medium"></use>
            </svg>
          </button>
        </div>
      </div>

      <div class="modal-alert__content">
        <div class="container">
          <!-- <app-question-generic-miniflow-parent
          *ngIf="question?.dependant_flow_id"
          [question]="question">
        </app-question-generic-miniflow-parent> -->

        @if (question?.dependant_flow_id) {
          <app-question-mini-flow-controller
            [question]="question"
            (questionAnswer)="submitResponse($event)">
          </app-question-mini-flow-controller>
        }

      </div>
    </div>

    <div class="modal-alert__button">
      <div class="container">
        <a href="#" class="button button--lg button--primary" (click)="populateClaimDetails()" data-toggle="modal"
        data-dismiss="modal">Done</a>
      </div>
    </div>
  </div>
</div>
</div>

